import {appFactory} from '@modifi/app'
import {clientConfig} from '@modifi/client-config'
import {
  AUTH_TYPE_ADMIN,
  CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL,
} from '@modifi/plugin-authentication/register'
import {withSuspense} from '@modifi/plugin-onboarding'
import ms from 'ms'

import routes from './routes'
import reducers from './reducers'
import {initPlugins} from './plugins'
import './dialogs/setup'
import Layout from './layouts'

const getApp = async (options: Record<string, any> = {}): Promise<any> => {
  await initPlugins(options?.plugins)

  clientConfig.set(CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL, ms('4m'))

  return appFactory({
    client: 'kartavya',
    appType: AUTH_TYPE_ADMIN,
    routes,
    reducers,
    layout: Layout,
    hoc: withSuspense(),
  })
}

export default getApp
